import { useEffect, useState } from "react";

const MOBILE_MEDIA_QUERY = "(width < 48rem)";

const getIsMobile = () =>
  typeof window !== "undefined" &&
  window.matchMedia(MOBILE_MEDIA_QUERY).matches;

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isMobile;
};
